exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body {\r\n    min-height: 100px;\r\n    text-align: center;\r\n}\r\n\r\ndiv a img {\r\n    margin-top: 100px;\r\n    width: 100px;\r\n}\r\n\r\niframe {\r\n    display: block;\r\n    width: 70%;\r\n    margin-top: 10px;\r\n    margin-bottom: 100px;\r\n    background-color: white;\r\n    overflow:hidden;\r\n}\r\n\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/calvi/Documents/AngularProjects/calvinparksportfolio/src/app/components/demos/demos.component.css
// module id = ../../../../../src/app/components/demos/demos.component.css
// module chunks = main